'use client';

import { forwardRef } from 'react';

import { cx } from '@/styled-system/css';

import { Icon } from '../icon/icon';
import { tabsTabIconRecipe } from './styles/tabs-tab-icon.styles';
import type { TabsTabIconPropsInterface } from './types/tabs-tab-icon.types';

/**
 * @since 10.0.0
 */
export const TabsTabIcon = forwardRef<SVGSVGElement, TabsTabIconPropsInterface>(
  (props: TabsTabIconPropsInterface, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;

    return (
      <Icon
        data-c11n-component="Tabs.TabIcon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        size="md"
        css={{ ...tabsTabIconRecipe.raw(), ...cssProp }}
        {...rest}
        className={cx('c11n_tabs__tab-icon', rest.className)}
      >
        {children}
      </Icon>
    );
  },
);

TabsTabIcon.displayName = 'Tabs.TabIcon';
